import { render, staticRenderFns } from "./customer-onetime.vue?vue&type=template&id=4fb1369e"
import script from "./customer-onetime.vue?vue&type=script&lang=js"
export * from "./customer-onetime.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports